import { Link } from 'react-router-dom';
import { experimentalStyled } from '@material-ui/core/styles';

const LogoWrapper = experimentalStyled(Link)(
  ({ theme }) => `
        color: ${theme.palette.text.primary};
        display: flex;
        align-items: center;
        justify-content: center;
        text-decoration: none;
        font-weight: ${theme.typography.fontWeightBold};
`
);

function JustCardioTextLogo() {
  return (
    <LogoWrapper to="/">
      {/* <LogoSignWrapper> */}
      <img
        alt=""
        src="/static/images/logo/actimi-telecare.png"
        style={{
          width: 70,
          height: 65
        }}
      />
    </LogoWrapper>
  );
}

export default JustCardioTextLogo;
